import { CheckIcon, ChartBarIcon } from '@heroicons/react/24/solid';
import { Helmet } from 'react-helmet-async';
import BackgroundPages from '@/global/Background/BackgroundPages';
import { FEATURE_TRIAL_DAYS } from './constants';
import styles from './FeatureBilling.module.css';

const NEXT_STEPS = [
  'Ranked GSEA is unlocked and ready to run.',
  'During the trial, analyses use CURATED sources. If you chose Pro, all sources unlock after day 7.',
  `You will not be charged until day ${FEATURE_TRIAL_DAYS}. Cancel anytime from your profile.`,
];

type FeatureTrialSuccessProps = {
  onStartAnalysis: () => void;
  onManageSubscription: () => void;
};

export default function FeatureTrialSuccess({
  onStartAnalysis,
  onManageSubscription,
}: FeatureTrialSuccessProps) {
  return (
    <>
      <Helmet>
        <title>GSEA trial started - DISGENET</title>
        <meta
          name="description"
          content="Your DISGENET GSEA trial is live. Start an analysis or manage your subscription."
        />
      </Helmet>

      <div className={styles.successPage}>
        <BackgroundPages />
        <div className={styles.successInner}>
          <div className={`${styles.paywallIcon} ${styles.successIcon}`} aria-hidden>
            <ChartBarIcon />
          </div>
          <div className={styles.successCard}>
            <p className={styles.successBadge}>{FEATURE_TRIAL_DAYS}-day trial</p>
            <h1 className={styles.successTitle}>Your GSEA trial is live</h1>
            <p className={styles.successBody}>
              Stripe Checkout is done. You can start an analysis now — nothing else to set up.
            </p>
            <ul className={styles.successList}>
              {NEXT_STEPS.map(item => (
                <li key={item}>
                  <CheckIcon className={styles.check} aria-hidden />
                  {item}
                </li>
              ))}
            </ul>
            <div className={styles.successActions}>
              <button type="button" className={styles.paywallCta} onClick={onStartAnalysis}>
                Start a GSEA analysis
              </button>
              <button type="button" className={styles.successSecondary} onClick={onManageSubscription}>
                Manage subscription
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
